import React, { useState, useEffect } from 'react';
import { updateFaseDeObra } from '../services/api';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from '@mui/material';
import { FaseObra } from '../services/types';

interface FaseObraEditModalProps {
    fase: FaseObra | null;
    open: boolean;
    onClose: () => void;
    onFaseObraUpdated: () => void;
}

const FaseObraEditModal: React.FC<FaseObraEditModalProps> = ({ fase, open, onClose, onFaseObraUpdated }) => {
    const [nome, setNome] = useState('');
    const [tipoFluxo, setTipoFluxo] = useState<'construcao' | 'leilao'>('construcao');
    const [ordem, setOrdem] = useState<number>(0);

    useEffect(() => {
        if (fase) {
            setNome(fase.nome);
            setTipoFluxo(fase.tipo_fluxo || 'construcao');
            setOrdem(fase.ordem || 0);
        }
    }, [fase]);

    const handleSave = async () => {
        if (!fase) return;
        const updatedFase = { nome, tipo_fluxo: tipoFluxo, ordem };
        try {
            await updateFaseDeObra(fase.id, updatedFase);
            onFaseObraUpdated();
            onClose();
        } catch (error) {
            alert('Erro ao atualizar fase da obra.');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Editar Fase da Obra</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}>
                <TextField
                    select
                    label="Tipo de Fluxo"
                    value={tipoFluxo}
                    onChange={e => setTipoFluxo(e.target.value as 'construcao' | 'leilao')}
                    fullWidth
                >
                    <MenuItem value="construcao">Construção</MenuItem>
                    <MenuItem value="leilao">Leilão</MenuItem>
                </TextField>
                <TextField label="Nome da Fase" value={nome} onChange={e => setNome(e.target.value)} required />
                <TextField
                    label="Ordem"
                    type="number"
                    value={ordem}
                    onChange={e => setOrdem(Number(e.target.value))}
                    required
                    helperText="Número sequencial da fase dentro do fluxo"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleSave} variant="contained">Salvar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default FaseObraEditModal;
